
export const environment = {
  production: false,
  // baseUrl: 'http://localhost:5001',
//baseUrl:"https://wooffertechnologies-qa.chetu.com",
  // baseUrl: 'https://wooffertechnologies.com/backend',
baseUrl: 'https://uat.wooffertechnologies.com/backend',

  stripeKey:'pk_live_51ILzC7JhmVYjS7hQ70RRKAuzMjqWCDkZRP7OwAoGSZuWB0ep1gisSH8DlSX4cEakhvOCEMg8HhXdZBENGdNFF9go00jX5H0Uws',
  //stripeKey:'pk_test_51ILzC7JhmVYjS7hQf2CG498i303bgCd7po0sbDtGHjt2dOWwGYk5DsH2NH5ZnbwqJIJEEt7h8TOdEK3GewUs7jQk009iU3VJsf',
  encryptionKey: 'x90dh!2$bs',
  appConfig: {
    currency: {
      code: 'USD',
      symbol: '$'
    },
    defaultPageSize: 10
  }
};




